import { useEffect, useState } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"

import { getProducts } from "../../../services/productService"
import { buyMore } from "../../../services/paymentService"

import {
  ChoosePricingSection,
  Spinner,
  SubscriptionButton
} from "../../common"
import { PLAN_TYPES, TALK_TO_US_URL } from "../../../constants"

import {
  setClientSecret,
  setInvoiceId,
  setProduct,
  setQuantity,
} from "../../../redux/slices/signupSlice"

import { useTokens } from "../../../hooks/useTokens"

const BuyMorePage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { formatMessage } = useIntl()
  
  const auth = useSelector((state) => state.auth)
  const { availableTokens } = useTokens({});

  const [loading, setLoading] = useState(false)
  const [productsLoading, setProductsLoading] = useState(true)
  const [products, setProducts] = useState([])

  const isEnterprise = auth.onboardingStage === "Enterprise";

  const handleSelectedProductChange = (product, quantity) => {
    dispatch(setProduct(product))
    dispatch(setQuantity(quantity))
  }

  const handleContinueClick = async (quantity = 1) => {
    // TODO: implement a better way of selecting the product
    const selectedProduct = products.at(0);

    if (!selectedProduct) {
      toast.error(formatMessage({ id: "toast.somethingWentWrong" }));
      console.error("Selected product not found");
      return;
    }

    handleSelectedProductChange(selectedProduct, quantity);

    try {
      setLoading(true)
      const data = await buyMore({ productId: selectedProduct.id, quantity })

      if (!data.clientSecret) {
        throw new Error("No client secret found")
      }

      dispatch(setClientSecret(data.clientSecret))
      dispatch(setInvoiceId(data.invoiceId || null))

      navigate("/payment")
    } catch (err) {
      console.error(err?.message)
      toast.error(formatMessage({ id: "toast.somethingWentWrong" }))
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const fetchProducts = async () => {
      setProductsLoading(true)
      getProducts()
        .then((data) => {
          const allProducts = [...data.products]
          allProducts.reverse()
          setProducts(
            allProducts
              .filter(({ productType }) => productType === "OneTime")
              .sort((a, b) => b.id - a.id),
          )
        })
        .finally(() => {
          setProductsLoading(false)
        })
    }

    fetchProducts()
  }, [])

  if (productsLoading) {
    return (
      <div className="choose-pricing">
        <div className="choose-pricing__loader">
          <Spinner />
        </div>
      </div>
    )
  }

  return (
    <>
      <div className="buy-more">
        {!isEnterprise && (
          <div className="ran-out">
            <div className="ran-out__wrapper">
              <div className="ran-out__content">
                <p className="h4">
                  <FormattedMessage id="common.runOutAlready" />
                </p>
                <p className="p">
                  <FormattedMessage
                    id="message.enterprisePlan"
                    values={{ bold: (chunks) => <b>{chunks}</b> }}
                  />
                </p>
              </div>

              <SubscriptionButton
                isLowcost={false}
                onClick={() => window.open(TALK_TO_US_URL, "_blank")}
                text={formatMessage({ id: "common.getAQuote" })}
              />
            </div>
          </div>
        )}



        <div className="ran-out">
          <h4>
            <FormattedMessage
              id="message.youHaveCredits"
              values={{ tokens: availableTokens }}
            />
          </h4>

          <ChoosePricingSection
            oneTimeOnly
            planType={PLAN_TYPES.PREMIUM}
            handleContinueClick={handleContinueClick}
            loading={loading}
          />
        </div>
      </div>
    </>
  )
}

export default BuyMorePage
